import Component from './message_queue_message_table.vue'
export default Component
